/** Presets visuais HUD para slides ARCA. */
export const SLIDE_THEMES = {
  'cyber-hud': {
    id: 'cyber-hud',
    label: 'Cyber HUD Blue',
    bg: '#0f172a',
    surface: '#1e293b',
    accent: '#38bdf8',
    text: '#f8fafc',
    muted: '#94a3b8',
    border: 'rgba(56,189,248,0.2)',
    glow: '0 0 20px rgba(56,189,248,0.12)',
  },
  midnight: {
    id: 'midnight',
    label: 'Midnight Slate',
    bg: '#020617',
    surface: '#0f172a',
    accent: '#818cf8',
    text: '#f1f5f9',
    muted: '#64748b',
    border: 'rgba(129,140,248,0.25)',
    glow: '0 0 18px rgba(129,140,248,0.1)',
  },
  arctic: {
    id: 'arctic',
    label: 'Arctic Frost',
    bg: '#0c4a6e',
    surface: '#075985',
    accent: '#e0f2fe',
    text: '#f0f9ff',
    muted: '#bae6fd',
    border: 'rgba(224,242,254,0.3)',
    glow: '0 0 16px rgba(186,230,253,0.15)',
  },
  ember: {
    id: 'ember',
    label: 'Ember Executive',
    bg: '#1c1917',
    surface: '#292524',
    accent: '#fb923c',
    text: '#fafaf9',
    muted: '#a8a29e',
    border: 'rgba(251,146,60,0.25)',
    glow: '0 0 18px rgba(251,146,60,0.1)',
  },
};

export const DEFAULT_THEME_ID = 'cyber-hud';

export function resolveSlideTheme(themeId) {
  return SLIDE_THEMES[themeId] || SLIDE_THEMES[DEFAULT_THEME_ID];
}

/** Paleta HUD compartilhada pelo editor (shell, painéis, chrome). */
export const HUD = {
  bgDeep: '#0b1329',
  bgPanel: '#0f172a',
  bgElevated: '#1e293b',
  border: 'rgba(255,255,255,0.06)',
  borderAccent: 'rgba(56,189,248,0.2)',
  text: '#f8fafc',
  muted: '#94a3b8',
  subtle: '#64748b',
  accent: '#38bdf8',
  danger: '#f43f5e',
  glow: '0 0 20px rgba(56,189,248,0.1)',
};
